import { HttpRequest, HttpEvent, HttpHandler, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CsrfService, CSRF_HEADER_NAME } from './csrf.service';

export const BYPASS_LOG = new HttpContextToken(() => false);

@Injectable({
    providedIn: 'root'
})
export class HttpOIDCInterceptorService implements HttpInterceptor {
    constructor(private readonly csrfService: CsrfService) {}

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (httpRequest.context.get(BYPASS_LOG) === true) {
            return next.handle(httpRequest);
        }

        const credentialedRequest = httpRequest.withCredentials
            ? httpRequest
            : httpRequest.clone({ withCredentials: true });

        if (!this.requiresCsrfHeader(credentialedRequest)) {
            return next.handle(credentialedRequest);
        }

        return from(this.csrfService.ensureToken()).pipe(
            switchMap(token => {
                if (!token) {
                    throw new Error('Missing CSRF token');
                }

                return next.handle(credentialedRequest.clone({
                    setHeaders: {
                        [CSRF_HEADER_NAME]: token
                    }
                }));
            })
        );
    }

    private requiresCsrfHeader(httpRequest: HttpRequest<any>): boolean {
        return this.isUnsafeMethod(httpRequest.method) && this.csrfService.isApiRequest(httpRequest.url);
    }

    private isUnsafeMethod(method: string): boolean {
        return ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase());
    }
}
